import React, { useState } from "react";
import { FAQItem } from "../../../data/faq";
import {
  AccordionContainer,
  AccordionItem,
  Question,
  Answer,
} from "./index.styles";
import { Typography } from "@mui/material";

interface FAQAccordionProps {
  items: FAQItem[];
}

const FAQAccordion: React.FC<FAQAccordionProps> = ({ items }) => {
  const [activeId, setActiveId] = useState<string | null>(items[0].id);

  const toggleAccordion = (id: string) => {
    setActiveId(activeId === id ? null : id);
  };

  return (
    <AccordionContainer>
      {items.map((item) => (
        <AccordionItem key={item.id} isActive>
          <Question onClick={() => toggleAccordion(item.id)}>
            <Typography variant="h4">{item.question}</Typography>
          </Question>
          <Answer isActive>
            <Typography variant="body1">{item.answer}</Typography>
          </Answer>
        </AccordionItem>
      ))}
    </AccordionContainer>
  );
};

export default FAQAccordion;
